// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C8-J","footer":"styles_footer__2Kdlj"};